import { useMemo as e } from "react";
//#region src/components/Table/useTableColumns.ts
var t = (e) => typeof e == "number" ? `${e}px` : e ?? "150px", n = ({ columns: n, selectable: r, rowActions: i }) => e(() => {
	let e = [], a = "";
	r && (e.push({
		id: "__selection__",
		header: "",
		width: "48px",
		align: "center",
		pinned: "left",
		_offset: "0px"
	}), a = "48px");
	let o = n.map((e) => {
		let n = { ...e };
		return e.pinned === "left" && (n._offset = a || "0px", a = `calc(${a || "0px"} + ${t(e.width)})`), n;
	}), s = "";
	i && (s = "64px");
	for (let e = o.length - 1; e >= 0; e--) o[e].pinned === "right" && (o[e]._offset = s || "0px", s = `calc(${s || "0px"} + ${t(o[e].width)})`);
	return e.push(...o), i && e.push({
		id: "__actions__",
		header: "",
		width: "64px",
		align: "center",
		pinned: "right",
		_offset: "0px"
	}), e;
}, [
	n,
	r,
	i
]);
//#endregion
export { t as calcWidthStr, n as useTableColumns };
